var $class="se2--content-support-module",$name="ContentSupportModule",$path="app/components/ContentSupportModule/utilities/getPageUrl.js",$this={$class,$name,$path,};const { origin, pathname } = window.location;

const getPageUrl = () => origin + pathname;

export default getPageUrl;
